const organizationFields =
  "id,name,organization_representative,company_information,individual_information,linked_projects_via_vehicle";

const topcisFields =
  "id,title,content,assembly.fields(id),choices,majority,answers,final_status_after_voting,created_at,updated_at";

const assemblyParticipantFields =
  "id,user,participation_channel,presence_confirmation,assembly.fields(id),answers.fields(id,choices,assembly_topic.fields(title)),status,convocation_document,proxy_type,proxy_document,signed_proxy_document,signed_vote_document,proxy_status,proxy_signature_request.fields(id,status,my_signature_link),vote_signature_request.fields(id,status,my_signature_link),convocation_send_date,created_at,updated_at";

export const USER_ASSEMBLY_QUERY_FIELDS = `
id,
name,
status,
scheduled_start_date,
scheduled_end_date,
organization.fields(${organizationFields}),
documents,
configuration,
topics.fields(${topcisFields}),
my_participation.fields(${assemblyParticipantFields}),
`;
